import Loading from "@notemeal/shared/ui/global/Loading";
import { useOffsetPagination } from "apps/web/src/utils/pagination";
import React, { useState } from "react";
import { FoodGroupDashboard } from "../../../../components/FoodGroup/Dashboard";
import { makeUpdateCacheCreateFoodGroup, makeUpdateCacheEditFoodGroup } from "../../../../components/FoodGroup/utils";
import { useCreateSharedFoodGroupMutation, useEditSharedFoodGroupMutation, useSharedFoodGroupsTableQuery } from "../../../../types";

const updateCacheCreateFoodGroup = makeUpdateCacheCreateFoodGroup({
  scope: "shared",
});
const updateCacheEditFoodGroup = makeUpdateCacheEditFoodGroup({
  scope: "shared",
});

export const FoodGroupsPage = () => {
  const [sortOrder, setSortOrder] = useState<"ASC" | "DESC">("ASC");
  const paginationHooks = useOffsetPagination();
  const { limit, offset, query } = paginationHooks;

  const sharedQueryResult = useSharedFoodGroupsTableQuery({
    variables: { query, input: { limit, offset }, sortOrder },
  });

  const [createFoodGroup] = useCreateSharedFoodGroupMutation();
  const [editFoodGroup] = useEditSharedFoodGroupMutation({
    update: (cache, mutationResult) => {
      updateCacheEditFoodGroup({ cache, mutationResult });
    },
  });

  if (!sharedQueryResult.data || !!sharedQueryResult.loading) {
    return <Loading />;
  }

  return (
    <FoodGroupDashboard
      editFoodGroup={editFoodGroup}
      createFoodGroup={createFoodGroup}
      updateCacheCreateFoodGroup={updateCacheCreateFoodGroup}
      foodGroups={sharedQueryResult.data.sharedFoodGroupsOffsetConnection.edges}
      paginationHooks={paginationHooks}
      total={sharedQueryResult.data.sharedFoodGroupsOffsetConnection.pageInfo.total || 0}
      setSortOrder={setSortOrder}
      sortOrder={sortOrder}
    />
  );
};
